// frontend/src/App.jsx (完成コード)
import React, { useState, useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Link,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Home from "./pages/Home";
import Register from "./pages/Register";
import Login from "./pages/Login";
import StudentHome from "./pages/StudentHome";
import TeacherHome from "./pages/TeacherHome";
import StudentVideoHistory from "./pages/StudentVideoHistory";
import TeacherVideoUpload from "./pages/TeacherVideoUpload";
import TeacherVideoDetail from "./pages/TeacherVideoDetail";
import TeacherStudentHistory from "./pages/TeacherStudentHistory";
import TeacherStudentList from "./pages/TeacherStudentList";
import TeacherSubjects from "./pages/TeacherSubjects"; 
import VideoAnalytics from "./pages/VideoAnalytics";
import VideoAnalyticsDetail from "./pages/VideoAnalyticsDetail";
import AdminPage from "./pages/AdminPage";
import AdminBulkRegister from "./pages/AdminBulkRegister";
import AdminAtRisk from "./pages/AdminAtRisk";
import TeacherRoute from "./routes/TeacherRoute";
import AdminRoute from "./routes/AdminRoute";
import Footer from "./components/Footer";
import { getMe } from "./services/authService";
import { getSubjects } from "./services/subjectService"; // ★ 新しいサービスをインポート

import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Button,
  Box,
  Container,
  useTheme,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import SchoolIcon from "@mui/icons-material/School";
import GroupsIcon from "@mui/icons-material/Groups";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import HomeIcon from '@mui/icons-material/Home';
import AnalyticsIcon from '@mui/icons-material/Analytics';

function AppContent() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [user, setUser] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [logoutConfirmOpen, setLogoutConfirmOpen] = useState(false);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      getMe()
        .then((u) => {
          setUser(u);
          if (u.role === "teacher" && (pathname === "/login" || pathname === "/")) {
            navigate("/teacher/home", { replace: true });
          } else if (u.role === "student" && (pathname === "/login" || pathname === "/")) {
            navigate("/student/home", { replace: true });
          } else if (u.role === "admin" && (pathname === "/login" || pathname === "/")) {
            navigate("/admin/at-risk", { replace: true });
          }
        })
        .catch(() => {
          localStorage.removeItem("token");
          setUser(null);
          if (pathname !== "/" && pathname !== "/register" && !pathname.startsWith("/login")) {
            navigate("/login");
          }
        });
    } else {
      setUser(null);
    }
  }, [token, navigate, pathname]);

  const performLogout = () => {
    localStorage.removeItem("token");
    setUser(null);
    navigate("/login");
    setLogoutConfirmOpen(false);
  };

  const handleLogout = () => {
    setLogoutConfirmOpen(true);
  };

  let menuItems = [];

  if (!user) {
    menuItems = [
      { label: "Login", to: "/login" },
    ];
  } else if (user.role === "student") {
    menuItems = [
      { label: "History", to: "/student/history" },
      { label: "Logout", action: handleLogout },
    ];
  } else if (user.role === "teacher") {
    menuItems = [
      { label: "Home", to: "/teacher/home", icon: <HomeIcon /> },
      { label: "留年リスク", to: "/admin/at-risk", icon: <AnalyticsIcon /> },
      { label: "Video", to: "/video-analytics", icon: <AnalyticsIcon /> },
      { label: "科目管理", to: "/teacher/subjects" },
      { label: "Students", to: "/teacher/students" },
      { label: "Video Upload", to: "/teacher/video-upload" },
      { label: "Logout", action: handleLogout },
    ];
  } else if (user.role === "admin") {
    menuItems = [
      { label: "留年リスク", to: "/admin/at-risk", icon: <AnalyticsIcon /> },
      { label: "ユーザー管理", to: "/admin/users" },
      { label: "一括登録", to: "/admin/bulk-register" },
      { label: "動画アップロード", to: "/teacher/video-upload" },
      { label: "Logout", action: handleLogout },
    ];
  }

  const roleIcon = !user
    ? null
    : user.role === "student"
    ? <SchoolIcon sx={{ mr: 0.5, color: "#FFF" }} />
    : user.role === "teacher"
    ? <GroupsIcon sx={{ mr: 0.5, color: "#FFF" }} />
    : <AdminPanelSettingsIcon sx={{ mr: 0.5, color: "#FFF" }} />;

  const open = Boolean(anchorEl);
  const handleMenuOpen = (e) => setAnchorEl(e.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const userLabel = user
    ? `${user.email.split("@")[0].replace(/^s/, "")} ${user.full_name || ''}`
    : "";

  return (
    <>
      <AppBar position="static" color="default" sx={{
        backgroundColor: '#121212',
        borderBottom: '1px solid',
        borderColor: 'grey.800',
      }}>
        <Toolbar>
          {isMobile && (
            <IconButton edge="start" color="inherit" onClick={handleMenuOpen} sx={{ mr: 2 }}>
              <MenuIcon />
            </IconButton>
          )}
          <Typography
            variant="h6"
            component={Link}
            to={user ? (user.role === "teacher" ? "/teacher/home" : user.role === "student" ? "/student/home" : user.role === "admin" ? "/admin/at-risk" : "/") : "/"}
            sx={{ flexGrow: 1, textDecoration: "none", color: "inherit", fontWeight: "bold" }}
          >
            Co-Edu LMS
          </Typography>
          {user && (
            <Box sx={{ mr: 2, display: "flex", alignItems: "center", whiteSpace: "nowrap" }}>
              {roleIcon}
              <Typography variant="subtitle2" sx={{ fontSize: "0.85rem" }}>
                ユーザ名：{userLabel}
              </Typography>
            </Box>
          )}
          {!isMobile && (
            <Box sx={{ display: "flex", gap: 1 }}>
              {menuItems.map(({ label, to, action, icon }) =>
                to ? (
                  <Button
                    key={label}
                    component={Link}
                    to={to}
                    color="inherit"
                    variant={pathname === to ? "contained" : "outlined"}
                    startIcon={icon}
                    sx={{
                      textTransform: "none", borderRadius: 2, borderColor: 'grey.700',
                      ...(pathname === to && {
                        backgroundColor: '#76b900', color: '#000', fontWeight: 'bold',
                        '&:hover': { backgroundColor: '#5c8f00' },
                      }),
                    }}
                  >
                    {label}
                  </Button>
                ) : (
                  <Button
                    key={label}
                    onClick={action}
                    color="inherit"
                    variant="outlined"
                    startIcon={icon}
                    sx={{ textTransform: "none", borderRadius: 2, borderColor: 'grey.700' }}
                  >
                    {label}
                  </Button>
                )
              )}
            </Box>
          )}
          {isMobile && (
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
            >
              {menuItems.map(({ label, to, action, icon }) => (
                <MenuItem
                  key={label}
                  component={to ? Link : undefined}
                  to={to}
                  onClick={() => {
                    handleMenuClose();
                    if (action) action();
                  }}
                  sx={{ fontSize: "0.9rem" }}
                >
                  {icon && <Box component="span" sx={{ mr:1, display: 'flex', alignItems: 'center' }}>{icon}</Box>}
                  {label}
                </MenuItem>
              ))}
            </Menu>
          )}
        </Toolbar>
      </AppBar>

      <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        {/* Logout Confirmation Dialog */}
        <Dialog
          open={logoutConfirmOpen}
          onClose={() => setLogoutConfirmOpen(false)}
        >
          <DialogTitle>ログアウトしますか？</DialogTitle>
          <DialogContent>
            <Typography>現在のセッションを終了してログイン画面へ戻ります。</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setLogoutConfirmOpen(false)} color="inherit" variant="text">
              キャンセル
            </Button>
            <Button onClick={performLogout} color="error" variant="contained">
              ログアウト
            </Button>
          </DialogActions>
        </Dialog>

        <Container component="main" sx={{ flex: 1, py: 4 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />

            {/* 学生向け */}
            <Route path="/student/home" element={<StudentHome />} />
            <Route path="/student/history" element={<StudentVideoHistory />} />

            {/* 教員向け */}
            <Route path="/teacher/home" element={
              <TeacherRoute><TeacherHome /></TeacherRoute>} />
            <Route path="/teacher/video-upload" element={
              <TeacherRoute><TeacherVideoUpload /></TeacherRoute>} />
            <Route path="/teacher/video/:videoId" element={
              <TeacherRoute><TeacherVideoDetail /></TeacherRoute>} />
            <Route path="/teacher/student/:studentId/history" element={
              <TeacherRoute><TeacherStudentHistory /></TeacherRoute>} />
            <Route path="/teacher/students" element={     
              <TeacherRoute><TeacherStudentList /></TeacherRoute>} />
            {/* ▼▼▼ 新しい科目管理ページへのルートを追加 ▼▼▼ */}
            <Route path="/teacher/subjects" element={     
              <TeacherRoute><TeacherSubjects /></TeacherRoute>} />
            {/* ▲▲▲ ここまで ▲▲▲ */}
            
            {/* 動画分析ページ */}
            <Route path="/video-analytics" element={
              <TeacherRoute><VideoAnalytics /></TeacherRoute>} />
            <Route path="/video-analytics/:videoId" element={
              <TeacherRoute><VideoAnalyticsDetail /></TeacherRoute>} />

            {/* 管理者向け */}
            <Route path="/admin/users" element={
              <AdminRoute><AdminPage /></AdminRoute>} />
            <Route path="/admin/bulk-register" element={
              <AdminRoute><AdminBulkRegister /></AdminRoute>} />
            {/* 留年リスク画面は教員・管理者の両方が閲覧可 */}
            <Route path="/admin/at-risk" element={
              <TeacherRoute><AdminAtRisk /></TeacherRoute>} />
          </Routes>
        </Container>
        <Footer />
      </Box>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}